// extracted by mini-css-extract-plugin
module.exports = {"tipContainer":"Tip_tipContainer__3MgvD"};